import React, { Component } from "react";
import Username from "./Username";
import { withRouter } from "react-router-dom";
import Post from "./Post";
import { Badge, Chip } from "@mui/material";
import StarIcon from '@mui/icons-material/Star';
class MiniPost extends Component {
  render() {
    const { post, history } = this.props;
    const backendApiPath = process.env.REACT_APP_BACKEND_API_PATH;
    return (
      <div className="mini-post">
          <Post post={post} showPostActions={false} />
      </div>
    );
  }
}
export default withRouter(MiniPost);
